import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { getCookie } from 'cookies-next';
import HeaderWithSidebar from '@app/components/templates/HeaderWithSidebar';
import Skeleton from '@app/components/atoms/Skeleton';
import SignupForm from '../../../components/organisms/auth/SignupForm';
// import { withApollo } from '../../../config/apollo';
import AuthTwoColumns from '../../../components/templates/AuthTwoColumns';
import { goToDashboard, isUser, redirectToRoute } from '../../../helpers';
import { OK } from '../../../constants/guard-code';
import { useTranslation } from '../../../config/i18n';

const Register = () => {
  const { t } = useTranslation('common');
  const [isAuth, setIsAuth] = useState(false)

  useEffect(() => {
    const accessToken = getCookie('token');
    
    if (!accessToken || accessToken === undefined || accessToken === null) {
      setIsAuth(false)
      redirectToRoute({}, 'register');
    }else {
      setIsAuth(true)
      redirectToRoute({}, 'opportunity_search');
    }
  }, []);

  return (
    <>
      { isAuth ?
        <HeaderWithSidebar contentPadding={0} >
          <Skeleton height="450px" />
        </HeaderWithSidebar>
      :
        <AuthTwoColumns title={t('register-new')} img="/images/login.png">
          <Head>
            <title>{t('register-new')}</title>
          </Head>
          <Container>
            <Typography variant="h4" component="h4" sx={{ marginBottom: '26px' }}>
              {t('register-new')}
            </Typography>
            <Grid item xs={12}>
              <SignupForm />
            </Grid>
          </Container>
        </AuthTwoColumns>
      }
    </>
  )
};

Register.guard = async (ctx, user) => {
  if (isUser(user)) {
    goToDashboard(ctx, user);
  }
  return OK;

}

export async function getServerSideProps() {
  return {
    props: {
      namespacesRequired: ['common', 'dashboard', 'wizard', 'payment', 'applications'],
    }
  }
}

export default Register;
